import styled from 'styled-components';

export const CartPreviewEditContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
